import { BooleanInput, Create, Datagrid, Edit, EditButton, FunctionField, List, ReferenceField, ReferenceInput, required, SelectInput, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput,ArrayInput,SimpleFormIterator,ArrayField,DateField, useRecordContext, DateInput, Toolbar, SaveButton } from "react-admin";
import { Link } from "react-router-dom";

export const ReimbursableReportCreate = () => (
    <Create>
        <SimpleForm>
            <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <SelectInput source="currency" choices={[
                { id: 'INR', name: 'INR' },
                { id: 'USD', name: 'USD' },
                { id: 'JPY', name: 'JPY' },
            ]} validate={required()} />
            <TextInput source="month_raw" validate={required()} />
            <TextInput source="name" label="Report Name" validate={required()} />
            <ReferenceInput source="last_report_id" reference="reimbursable_report"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <TextInput source="bill_no" label="Bill Number" />
            <ArrayInput source="invoice_labels" label="Invoice Labels">
                <SimpleFormIterator>
                <ReferenceInput source="company_id" reference="companies"><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
                <TextInput source= "invoice_no" label="Invoice No"/>
                <DateInput source="invoice_date" label="Invoice Date" />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);

export const ReimbursableReportEdit = () => (
    <Edit>
        <SimpleForm>
            Report Name :<TextField source="name" />
            <br/>GC :<ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <br/>Currency : <TextField source="currency" />
            <br/>Month Raw :<TextField source="month_raw" />
            <br/>Last Report  :<ReferenceField source="last_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
            <br/><BooleanInput source="refresh" label="Refresh Report?" />
            <SelectInput source="status" choices={[
                { id: 'draft', name: 'Draft' },
                { id: 'final', name: 'Final' },
            ]} />
            <InvoiceData />
        </SimpleForm>
    </Edit>
);


export const ReimbursableReportEditCA = () => (
    <Edit>
        <SimpleForm toolbar={<Toolbar><SaveButton /></Toolbar>}>
            Report Name :<TextField source="name" />
            <br/>GC :<ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <br/>Currency : <TextField source="currency" />
            <br/>Month Raw :<TextField source="month_raw" />
            <br/>Last Report  :<ReferenceField source="last_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
            <br/>Status :<TextField source="status" />
            <br/><BooleanInput source="refresh" label="Refresh Report?" />
            <InvoiceData />
        </SimpleForm>
    </Edit>
);

export const ReimbursableReportShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <TextField source="currency" />
            <TextField source="status" />
            <TextField source="month_raw" />
            {/* <TextField source="report_url" /> */}
            <ReferenceField source="last_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
            <TextField source="bill_no" />
            <ArrayField source="invoice_labels" label="Invoice Labels">
                <Datagrid>
                <ReferenceField source="company_id" reference="companies"><TextField source="full_name" /></ReferenceField>
                <TextField source= "invoice_no" label="Invoice No"/>
                <DateField source="invoice_date" label="Invoice Date" locales='en-IN'/> 
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);

const pCompFilters = [
    <ReferenceInput source="parent_company_id" reference="parent_companies" ><SelectInput optionText="name" optionValue="id"/></ReferenceInput>
];

export const ReimbursableReportList = () => (
    <List filters={pCompFilters}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <TextField source="status" />
            <TextField source="currency" />
            {/* <TextField source="report_url" /> */}
            <FunctionField label="Name" render={record => { 
                const url = "/report-download/reimbursable-report/" + record.id + "/"+record.name;
                return (<div><Link target="_blank" to={url}>Download</Link></div>);
                }} />
            <ShowButton label="View" />
            <EditButton label="Edit" />
        </Datagrid>
    </List>
);


const InvoiceData = () => {
    const report = useRecordContext();
    return <><TextInput source="bill_no" label="Bill Number" />
    <ArrayInput source="invoice_labels" label="Invoice Labels">
    <SimpleFormIterator>
    <ReferenceInput source="company_id" reference="companies" filter={{parent_company_id:report.parent_company_id}}><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
    <TextInput source= "invoice_no" label="Invoice No"/>
    <DateInput source="invoice_date" label="Invoice Date" />
    </SimpleFormIterator>
    </ArrayInput></>
}